import React, { ReactElement } from "react";

const BULLET = "M32 4 C38 14 41 28 41 50 L41 66 L23 66 L23 50 C23 28 26 14 32 4 Z";
const CASE = "M22 62 H42 V86 C42 94 50 98 50 108 V170 H14 V108 C14 98 22 94 22 86 Z";

/** A large rifle cartridge standing on its base: the illustration of the execution prompt. */
export default function BulletArt({ idPrefix = "bullet" }: { idPrefix?: string }): ReactElement {
  return (
    <svg
      className="bullet-art"
      viewBox="0 0 64 184"
      role="img"
      aria-label="A bullet"
      focusable="false"
    >
      <defs>
        <linearGradient id={idPrefix + "-jacket"} x1="0" x2="1" y1="0" y2="0">
          <stop offset="0" stopColor="#f6b27a" />
          <stop offset="0.45" stopColor="#cf7a3f" />
          <stop offset="1" stopColor="#7b3d1b" />
        </linearGradient>
        <linearGradient id={idPrefix + "-brass"} x1="0" x2="1" y1="0" y2="0">
          <stop offset="0" stopColor="#fbe08a" />
          <stop offset="0.4" stopColor="#e2b43f" />
          <stop offset="1" stopColor="#8f6614" />
        </linearGradient>
        <clipPath id={idPrefix + "-clip"}>
          <path d={BULLET} />
        </clipPath>
        <clipPath id={idPrefix + "-case-clip"}>
          <path d={CASE} />
        </clipPath>
      </defs>
      {/* Brass case: neck, shoulder and body */}
      <path d={CASE} fill={`url(#${idPrefix}-brass)`} />
      <g clipPath={`url(#${idPrefix}-case-clip)`}>
        <rect x="19" y="112" width="4" height="52" rx="2" fill="#fff" opacity="0.4" />
        <rect x="14" y="164" width="36" height="6" fill="#8f6614" opacity="0.5" />
      </g>
      <path d={CASE} fill="none" stroke="#4a3208" strokeWidth="2" strokeLinejoin="round" />
      {/* Rim at the base */}
      <rect x="10" y="170" width="44" height="10" rx="3" fill={`url(#${idPrefix}-brass)`} stroke="#4a3208" strokeWidth="2" />
      {/* Copper bullet seated in the neck */}
      <path d={BULLET} fill={`url(#${idPrefix}-jacket)`} />
      <g clipPath={`url(#${idPrefix}-clip)`}>
        <path d="M28.5 20 C27 30 27 44 27 62" stroke="#fff" strokeWidth="2.6" strokeLinecap="round" fill="none" opacity="0.45" />
        <rect x="23" y="62" width="18" height="4" fill="#4a210c" opacity="0.35" />
      </g>
      <path d={BULLET} fill="none" stroke="#4a210c" strokeWidth="2" strokeLinejoin="round" />
    </svg>
  );
}
